import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Other Help Request</h4>
  <p>
      The associate is not able to resolve the issue in hand and needs immediate assistance.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Reach out to the associate and understand the help required.<br />
      2. Follow the right SOP depending on the issue and resolve the problem faced by the associate.<br />
      3. Once you resolve the request mark task as completed.
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Other_Help_Request.jsx